// If a Mapbox Style contains duplicate sources, it will make duplicate network requests. This
// function merges identical sources to prevent that.

export default function dedupeMapboxStyleSources(style: mapboxgl.Style) {
    const groups: {[json: string]: string} = {};
    const duplicateSources: {[id: string]: string} = {};

    if ('sources' in style) {
        for (const id in style.sources!) {
            const source = style.sources![id];
            const key = JSON.stringify(source);

            if (!groups[key] || source.type !== 'vector') {
                groups[key] = id;
            } else {
                duplicateSources[id] = groups[key];
            }
        }
    }

    return {
        ...style,
        layers:
            style.layers &&
            style.layers
                .map((layer) => {
                    if (layer.type === 'custom') return undefined;
                    return {
                        ...layer,
                        ...(typeof layer.source === 'string' &&
                            duplicateSources[layer.source] && {
                                source: duplicateSources[layer.source],
                            }),
                    };
                })
                .filter(Boolean),
    };
}
